var exports = {
  "x": "x620889e6--74000c--button",
};

module.exports = exports;
